const initCards = function initCards()
{
  const cards = document.querySelectorAll('.cards .career_list__item');

  if( cards.length > 0 ) {
    cards.forEach( (item) => {
      item.addEventListener('click', (e) => {
        e.preventDefault();
        item.classList.toggle('active');
      });
    });
  }
}
export { initCards };